var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53289 1.65789C5.53289 1.36359 5.29431 1.125 5 1.125C4.70569 1.125 4.46711 1.36359 4.46711 1.65789V3.9671H2.15789C1.86359 3.9671 1.625 4.20569 1.625 4.5C1.625 4.79431 1.86358 5.03289 2.15789 5.03289L4.46711 5.03289V7.3421C4.46711 7.63642 4.70569 7.875 5 7.875C5.29431 7.875 5.53289 7.63642 5.53289 7.3421V5.03289L7.8421 5.03289C8.13642 5.03289 8.375 4.79431 8.375 4.5C8.375 4.20569 8.13642 3.96711 7.8421 3.96711L5.53289 3.9671V1.65789Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.ea8b07f46f18891fc1340dd4ccd22ad5.svg";